import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonImg, IonItem, IonText, IonList, IonLabel, IonGrid, IonRow, IonCol, IonButton } from '@ionic/react';
import { useParams } from 'react-router-dom';
import { Browser } from '@capacitor/browser';
import PageEventHandler from "../components/PageEventHandler"
import ListItems from '../components/ListItems';
import InnerMenu from '../components/InnerMenu';
import './Signs.css';
import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { signsTranslations } from '../translations/signs';
import NotificationRedirect from '../components/NotificationRedirect';

const Signs: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = signsTranslations[language];

  const pageName = "Segnaletica e Regolamento";
  let signs: [any] = [''];
  const rulebookUrl = "https://www.agenziapo.it/sites/default/files/dwd/attivita/navigazione_interna/segnaletica/regolamento_segnaletica.pdf";


  const showPdf = async () => {
    // await Browser.open({ url: '/assets/docs/regolamento_segnaletica.pdf'});
    await Browser.open({ url: 'https://www.agenziapo.it/sites/default/files/dwd/attivita/navigazione_interna/segnaletica/regolamento_segnaletica.pdf'});
    console.log('Doc aperto in browser');
  };

  return (
    <IonPage>
      <IonHeader>
        <InnerMenu name={t.pageTitle} />
      </IonHeader>
      <IonContent fullscreen>
        <IonItem lines="none">
          <h1 className="mainTit" slot="start">{t.pageTitle}</h1>
        </IonItem>
        <IonItem lines="none">
          <h2 className="subTit" slot="start">{t.subTitle}</h2>
        </IonItem>
        <div className="ion-padding">
          <div className="ion-text-justify">
            {t.mainDescription}
            <br/><br/>
            {t.consultReference}&nbsp;
          </div>
          <IonButton target="_blank" rel="noreferrer" href={rulebookUrl} expand="block" fill="solid" className="ion-padding signBtn">
            {t.downloadButton}
          </IonButton>

          <br />
          <div className="ion-margin-top">
            <h3>{t.generalTitle}</h3>
          </div>

          <div className="ion-text-justify">
            {t.generalDescription}
          </div>
        </div>

        <IonList>
          <IonItem key="1" button={false}>
            <IonImg className="ion-margin img-square" slot="start" alt="Segnale 1" src={`${process.env.PUBLIC_URL}/assets/images/sign-1.png`} />
            <p className="ion-padding-start"><b>{t.callSignal}</b>: {t.callDescription}</p>
          </IonItem>
          <IonItem key="2" button={false}>
            <IonImg class="ion-margin img-square" slot="start" alt="Segnale 2" src={`${process.env.PUBLIC_URL}/assets/images/sign-2.png`} />
            <p className="ion-padding-start"><b>{t.sendBackSignal}</b>: {t.sendBackDescription}</p>
          </IonItem>
          <IonItem key="3" button={false}>
            <IonImg class="ion-margin img-square" slot="start" alt="Segnale 3" src={`${process.env.PUBLIC_URL}/assets/images/sign-3.png`} />
            <p className="ion-padding-start"><b>{t.touchAndGoSignal}</b>: {t.touchAndGoDescription}</p>
          </IonItem>
          <IonItem key="4" button={false}>
              <IonImg class="ion-margin img-square" slot="start" alt="Segnale 4" src={`${process.env.PUBLIC_URL}/assets/images/sign-4.png`} />
            <p className="ion-padding-start"><b>{t.continuationSignal}</b>: {t.continuationDescription}</p>
          </IonItem>
        </IonList>

        <IonItem lines="none" className="ion-margin-top">
          <h4>{t.bridgeSignsTitle}</h4>
        </IonItem>

        <IonList>
          <IonItem key="5" button={false}>
            <IonImg className="ion-margin img-tall" slot="start" alt="Segnale 5" src={`${process.env.PUBLIC_URL}/assets/images/sign-5.jpg`} />
            <p className="ion-padding-start"><b>{t.whiteBouy}</b> {t.whiteBuoyDescription}</p>
          </IonItem>
          <IonItem key="6" button={false}>
            <IonImg className="ion-margin img-tall" slot="start" alt="Segnale 6" src={`${process.env.PUBLIC_URL}/assets/images/sign-6.jpg`} />
            <p className="ion-padding-start"><b>{t.redBouy}</b> {t.redBuoyDescription}</p>
          </IonItem>
          <div key="7" className="ion-padding">
            <IonImg className="ion-margin img-wide" slot="start" alt="Navigazione" src={`${process.env.PUBLIC_URL}/assets/images/sign-8.jpg`} />
          </div>
          <div key="8" className="ion-padding">
            <IonImg className="ion-margin img-wide" slot="start" alt="Segnali ponti" src={`${process.env.PUBLIC_URL}/assets/images/sign-7.jpg`} />
            <br />
            <p className="ion-text-justify"><b>{t.yellowLight}</b>: {t.yellowLightDescription}</p>
            <p className="ion-text-justify"><b>{t.redSignal}</b> {t.redSignalDescription}</p>
          </div>
        </IonList>

        <div className="ion-padding ion-text-justify">
          <h4>{t.referenceTitle}</h4>
          <h5>{t.regionalTitle}</h5>
          <ul>
            <li>Regione Emilia Romagna - Delibera Giunta regionale del 03/04/2002 n. 530 - Approvazione del regolamento della segnaletica e delle vie di navigazione interna</li>
            <li>Regione Piemonte - Regolamento regionale 7 giugno 2002, n. 6/R recante: "Regolamento della segnaletica e delle vie di navigazione interna fluviali"</li>
            <li>Regione Lombardia - Regolamento Regionale 26/09/2022 n.9 - Regolamento della segnaletica e delle vie di navigazione interna</li>
            <li>Regione Veneto - Regolamento regionale 20 dicembre 2002, n. 6</li>
          </ul>
        </div>

      </IonContent>
      <PageEventHandler pageIndex={8} dockIndex={0}/>
      <NotificationRedirect /> {/* redirect to the page specified in the local storage */}
    </IonPage>
  );
};

export default Signs;
